module.exports = __webpack_public_path__ + "img/home-library-2.a4b1fb54.png";